import { render } from "./TimeForm.vue?vue&type=template&id=c24b4a2c"
import script from "./TimeForm.vue?vue&type=script&lang=js"
export * from "./TimeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__